import { RolePermission } from '../types/user.type';

const hasPermissions = (required: string, permissions: RolePermission[]) => {
    return permissions.some((per) => per.name === required);
};

export { hasPermissions };
